import React, { useCallback, useEffect, useRef, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "dayjs/locale/en-gb";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import dayjs from "dayjs";
import SriyanshCardHeader from "../../components/CardHeader";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import { FormControlLabel, Checkbox } from "@mui/material";
import EncryptService from "../../service/EncryptionService";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";
import TablewithSumFooter from "../../CustomComponant/TablewithSumFooter";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
function PoPage() {
  const navigate = useNavigate();
  const [POReturnData, setPOReturnData] = useState([]);
  const [IndReturnData, setIndReturnData] = useState([]);
  const [poNumber, setpoNumber] = useState("");
  const [poItemName, setpoItemName] = useState("");
  const [poValue, setpoValue] = useState("");
  const [poQuantity, setpoQuantity] = useState("");
  const [poDate, setpoDate] = useState(null);
  const [dpDate, setdpDate] = useState(null);
  const [unit, setunit] = useState("");
  const [units, setunits] = useState([]);
  const [indentNo, setindentNo] = useState("");

  const [indentConsigneeName, setindentConsigneeName] = useState("");
  const { state } = useLocation();

  const indentId = useState(state.indent_id);

  const [minCalDate, setMinCalDate] = useState(dayjs());

  const today = dayjs();
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  const [selectedOption, setSelectedOption] = useState("");



  const [gemchecked, setgemChecked] = useState(false); // Default is false
  const [gemNumber, setGemNumber] = useState("GEMC-"); 
  const [gemDate, setGemDate] = useState(null);




  const [partyName, setPartyName] = useState("");
  const [partyAddress, setPartyAddress] = useState("");
  const [partyContact, setPartyContact] = useState("");
  const startRef = useRef(null);




  const handlegemChange = (event) => {
    let inputValue = event.target.value;

    // Ensure the input always starts with "GEMC-"
    if (!inputValue.startsWith("GEMC-")) {
      inputValue = "GEMC-";
    }

    // Restrict to maximum 16 characters
    if (inputValue.length <= 20) {
      setGemNumber(inputValue);
    }
  };


useEffect(() => {
  if (units.length === 0) return;

  // backend value
  const backendUnit = IndReturnData?.unit;

  if (backendUnit) {
    const exists = units.some(
      u => String(u.unitcode) === String(backendUnit)
    );

    setunit(exists ? backendUnit : "");
  }
}, [units, IndReturnData]);


  const handleClose = () => {
    navigate("../polist", { replace: true });
  };

  const handleQuantityChange = (value) => {
    setpoQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };
  const fetchUnit = async () => {
    try {
      const response = await apiClient.post("/unitList", {
        /* request payload if needed */
      });
      setunits(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };
  const handleValueChange = (value) => {
    setpoValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const InsertPOData = async (e) => {
    e.preventDefault();








    let formErrors = {};

    //if (podateerror) formErrors.errPODate = "Invalid PO Date";
   


    if (!gemchecked) {  // If gemchecked is false
      setGemNumber(null);
      setGemDate(null);
    }

  
    if (!dpDate)
      {
        formErrors.errDPDate = "Invalid DP Date";
        //alert("Invalid Date");
      } 

      if (!poDate)
        {
          formErrors.errPODate = "Invalid PO Date";
          //alert("Invalid Date");
        } 

    if (
      !poQuantity ||
      poQuantity.length === 0 ||
      isNaN(parseFloat(poQuantity)) ||
      parseFloat(poQuantity) <= 0
    ) {
      formErrors.qty = "Qty should be more than zero";
    }

    if (!poValue || isNaN(parseFloat(poValue)) || parseFloat(poValue) <= 0) {
      formErrors.val = "Value should be more than zero";
    }

    if (!poNumber || poNumber.length !== 14) {
      formErrors.po = "PO Number length should be exactly 14 characters";
    }

    if (gemchecked && typeof gemNumber === "string" && gemNumber.trim().length !== 20) {
      formErrors.gemno = "GeM Contract Number length should be exactly 20 characters";
  }
   
    if (!poItemName || poItemName.length === 0) {
      formErrors.name = "Item Name Should not be Blank";
    }

    if (!partyName || partyName.length === 0) {
      formErrors.partyName = "Party Name Should not be Blank";
    }

    if (!partyAddress || partyAddress.length === 0) {
      formErrors.partyAddress = "Party Address Should not be Blank";
    }

    if (selectedOption.length === 0) {
      formErrors.selerr = "Indent Type Not Selected";
    }
    setErrors(formErrors);

    //console.log(formErrors);
    if (Object.keys(formErrors).length === 0) {
      
      
      const podt = new Date(poDate);
      const indentreceiptdt =
        podt.getFullYear() +
        "/" +
        parseInt(podt.getMonth() + 1) +
        "/" +
        podt.getDate();
      const dpdt = new Date(dpDate);
      const DP_date =
        dpdt.getFullYear() +
        "/" +
        parseInt(dpdt.getMonth() + 1) +
        "/" +
        dpdt.getDate();

        const gemdt = gemchecked ? new Date(gemDate) : null;
        const gem_date = gemdt
          ? `${gemdt.getFullYear()}/${String(gemdt.getMonth() + 1).padStart(2, "0")}/${String(gemdt.getDate()).padStart(2, "0")}`
          : null;


      apiClient
        .post("/poentry", {
          indentNum: indentNo,
          poNumber,
          poItemName,
          poQuantity,
          poValue,
          consignee: indentConsigneeName,
          poDate: indentreceiptdt,
          uname,
          dpdate: DP_date,
          ip,
          potype: selectedOption,
          party_name: partyName,
          party_address: partyAddress,
          party_contact: partyContact ? partyContact : '',
          unit,
          gemtype:gemchecked,
          gemno:gemchecked ? gemNumber:null,
          gemdate:gemchecked? gem_date:null,
        })
        .then(function (response) {
          setError(response.data);

          navigate("../polist", { replace: true });
        })
        .catch(function (error) {
          if (
            error.response.data &&
            error.response.data.code === "ER_DUP_ENTRY"
          ) {
            alert("Duplicate PO Not Allowed");
          } else {
            alert(error.response.data.code);
          }
        });
    }
  };

  // const getdata = useCallback(
  //   async (e) => {
  //     try {
  //       const response = await apiClient.post("/indentdetails", {
  //         uname: uname,
  //         indentNumber: String(indentId),
  //       });

  //       setIndReturnData(response.data[0]);

  //       setindentNo(IndReturnData.indnumber);

  //       setindentConsigneeName(IndReturnData.consignee);
  //       setpoItemName(IndReturnData.inditem);
  //       //console.log(response.data[0]);
  //       setpoValue(IndReturnData.POValue);
  //       setpoQuantity(IndReturnData.POQuantity);
  //      // setunit(IndReturnData.unit);
  //       const minValueDate =
  //         "'" + dayjs(IndReturnData.inddate).format("YYYY-MM-DD") + "'";

  //       setMinCalDate(dayjs(minValueDate));
  //     } catch (error) {
  //       setError(error.response ? error.response.data : error.message);
  //     }
  //   },
  //   [indentNo, IndReturnData.POQuantity]
  // );



const getdata = useCallback(async () => {
  try {
    const response = await apiClient.post("/indentdetails", {
      uname,
      indentNumber: String(indentId),
    });

    const data = response.data[0];

    setIndReturnData(data);
    setindentNo(data.indnumber);
    setindentConsigneeName(data.consignee);
    setpoItemName(data.inditem);
    setpoValue(data.POValue);
    setpoQuantity(data.POQuantity);

    setMinCalDate(dayjs(data.inddate));
  } catch (error) {
    setError(error.response ? error.response.data : error.message);
  }
}, [uname, indentId]);







  const getPOdata = useCallback(async () => {
    // console.log("Indent",indentNo?indentNo:'');
    if (!indentNo || indentNo.trim() === "") return;
    try {
      const response = await apiClient.post("/getPO_Data_ByIndent", {
        indentnumber: indentNo,
      });

      // Check if response is successful and has the data
      if (response.status === 200 && response.data) {
        setPOReturnData(response.data);
      } else {
        // Handle cases where response is not as expected
        //console.error("Failed to fetch PO data:", response);
      }
    } catch (err) {
      // Log the error to see what went wrong
      //console.error("Error fetching PO data:", err);
    }
  }, [indentNo, POReturnData]); // Use only `indentNo` unless `IndReturnData.POQuantity` is needed for some reason

  
  
  
  
  useEffect(() => {
    getdata();
    getPOdata();
    fetchUnit();
    if (startRef.current) {
      startRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      
    }

  }, []);

  // useEffect(() => {
  //   if (!gemchecked) {  // If gemchecked is false
  //     setGemNumber(null);
  //     setGemDate(null);
  //   }
  // }, [gemchecked]);


  const columns = [
    "PONumber",
    "PODate",
    "DPDate",
    "POItemName",
    "ItemQuantity",
    "ItemValue",
  ];

  const columnNames = [
    "PO Number",
    "PO Date",
    "DP Date",
    "PO ItemName",
    "PO Qty",
    "PO Value",
  ]; // keys from your data objects

  const headers = [
    ["Indent Number", "Indent Item Name", "Consignee"],
    ["Indent date", "Indent Quantity", "Indent Value"],
    ["", "Balance PO Quantity", "Balance PO Value"],
  ];

  const rows = [
    [indentNo, IndReturnData.inditem, IndReturnData.consignee],
    [IndReturnData.inddate, IndReturnData.quantity, IndReturnData.indvalue],
    ["", IndReturnData.POQuantity, IndReturnData.POValue],
  ];

  const menuoptions = [
    { value: "0", label: "Full Indent PO" },
    { value: "1", label: "Partial Indent PO" },
    { value: "2", label: "Final PO of Partial Indent" },
  ];

  const handleChange = (event) => {
    const inputValue = event.target.value.toUpperCase();
    // Remove any non-alphanumeric characters
    const alphanumericValue = inputValue.replace(/[^a-zA-Z0-9]/g, "");
    setpoNumber(alphanumericValue);
  };

  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  return (
    <div className="col-12">
      {/* <SriyanshCardHeader Title="PO Data Entry" /> */}

      <Card className="Formcard" >
      <div className="input-groupHeading">
      PO Data Entry
            </div>
        {/* {error && (
          <ToasterAlerts
            type="info"
            title="Messasge"
            errorMessage={error}
            displaytime={2000}
            handleClose={() => {
              setError("");
            }}
          />
          ref={startRef}
        )} */}
        <CardContent>


        <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span" variant="h6">Indent Details</Typography>
        </AccordionSummary>
        <AccordionDetails>
        
            <ListHeaderTableComponent headers={headers} rows={rows} />
        
        </AccordionDetails>
      </Accordion>

<div className="row p-2" >
                <div className="container">
                  <div className="input-group mt-2" id="1" >
                    <CustomDropdownMenu
                      options={menuoptions}
                      selectedOption={selectedOption}
                      handleOptionChange={handleOptionChange}
                      error={error}
                      menulabel="Select PO Type"
                    />
                  </div>
                <div className="input-group">
                <FormControlLabel
      control={
        <Checkbox
          checked={gemchecked}
          onChange={(e) => setgemChecked(e.target.checked)}
          color="primary"
        />
      }
      label="Select if GeM Contract"
    />
                </div>


                <div className="input-group mt-2">
                    <CustomTextField
                      label="GeM Contract Number (Only 20 Character)*"
                      value={gemNumber || ""}
                      onChange={handlegemChange}
                      placeholder="GeM Contract Number length should be exactly 20 characters*"
                      maxLength={20} // Set the maximum length
                      //multiline={false} // Enable multiline
                      error={!!errors.gemno}
                      helperText={errors.gemno}
                      disabled={!gemchecked}
                    />
                  </div>


                  <div className="input-group ">
                    <DatePickerComponent
                      label="GeM Contract Date"
                      id="gemdate"
                      value={gemDate} // Set initial value to null
                      onChange={(newDate) =>
                        handleDateChange(newDate, setGemDate)
                      } // Pass setPoDate
                    //  error={errors.errPODate} // Display error
                      maxDate={today} // Restrict maximum date
                      minDate={minCalDate} // Restrict minimum date
                     disabled={!gemchecked}
                    />
</div>

                </div>

                <div className="container">
                  <div className="input-group">
                    <CustomTextField
                      label="PO Number (Only 14 Character)*"
                      value={poNumber || ""}
                      onChange={handleChange}
                      placeholder="PO Number length should be exactly 14 characters*"
                      maxLength={14} // Set the maximum length
                      //multiline={false} // Enable multiline
                      error={!!errors.po}
                      helperText={errors.po}
                    />
                  </div>
                  <div className="input-group">
                    <NumericTextField
                      id="ItemQuantity"
                      label="PO Item Quantity"
                      title="PO Item Quantity"
                      error={errors.qty}
                      value={poQuantity || ""}
                      onChange={handleQuantityChange}
                    />
                  </div>
                  <div className="input-group">
                    <DropdownfromDatabaseList
                      Options={units}
                      option={unit}
                      setOptionValue={setunit}
                      DisplayItem1="unit"
                      DisplayItem2="unitcode"
                      showKeyInLabel={true}
                    />
                  </div>

                  <div className="input-group">
                    <NumericTextField
                      id="ItemValue"
                      label="PO Item Value"
                      title="PO tem Value"
                      error={errors.val}
                      value={poValue || ""}
                      onChange={handleValueChange}
                    />
                  </div>
                </div>

                <div className="container">
                  <div className="input-group">
                    <CustomTextField
                      label="Enter Item Name (Max 200 Character)*"
                      value={poItemName || ""}
                      onChange={(e) => {
                        setpoItemName(e.target.value);
                      }}
                      placeholder="Enter Item Name (Max 200 Character)*"
                      maxLength={200} // Set the maximum length
                      multiline={true} // Enable multiline
                      minRows={4} // Set the minimum number of rows
                      error={!!errors.name}
                      helperText={errors.name}
                    />
                  </div>
                </div>

                <div className="container">
                  <div className="input-group">
                    <CustomTextField
                      label="Party Name (Max 100 Character)*"
                      value={partyName || ""}
                      onChange={(e) => {
                        setPartyName(e.target.value.toUpperCase()); // Convert input to uppercase
                      }}
                      // onChange={(e) => {
                      //   setPartyName(e.target.value);
                      // }}
                      placeholder="Party Name (Max 100 Character)*"
                      maxLength={100} // Set the maximum length
                      //multiline={false} // Enable multiline
                      error={!!errors.partyName}
                      helperText={errors.partyName}
                    />
                  </div>

                  <div className="input-group">
                    <CustomTextField
                      label="Party Address (Max 200 Character)*"
                      value={partyAddress || ""}
                      onChange={(e) => {
                        setPartyAddress(e.target.value.toUpperCase());
                      }}
                      placeholder="Party Address (Max 200 Character)*"
                      maxLength={200} // Set the maximum length
                      //multiline={false} // Enable multiline
                      error={!!errors.partyAddress}
                      helperText={errors.partyAddress}
                    />
                  </div>

                  <div className="input-group">
                    <CustomTextField
                      label="Party Contact Number (Max 10 Character)"
                      value={partyContact || ""}
                      onChange={(e) => {
                        setPartyContact(e.target.value);
                      }}
                      placeholder="Party Contact Number (Max 10 Character)"
                      maxLength={10} // Set the maximum length
                      //multiline={false} // Enable multiline
                      error={!!errors.partyContact}
                      helperText={errors.partyContact}
                    />
                  </div>
                </div>

                <div className="container">
                  <div className="input-group">
                    <DatePickerComponent
                      label="PO Date"
                      id="podate"
                      value={poDate} // Set initial value to null
                      onChange={(newDate) =>
                        handleDateChange(newDate, setpoDate)
                      } // Pass setPoDate
                      error={errors.errPODate} // Display error
                      maxDate={today} // Restrict maximum date
                      minDate={minCalDate} // Restrict minimum date
                    />
                    
                  </div>

                  <div className="input-group">
                    <DatePickerComponent
                      label="DP Date"
                      id="dpdate"
                      value={dpDate}
                      onChange={(newDate) =>
                        handleDateChange(newDate, setdpDate)
                      } // Pass setPoDate
                      error={errors.errDPDate} // Display error
                      minDate={dayjs(poDate) ?? minCalDate}
                    />
                    </div>
                    </div>  
            {/* ============================================LIST of ALL PO ===========================================*/}

            {POReturnData.length > 0 && (
              // <PoListTable POReturnData={POReturnData} />

              <TablewithSumFooter
                columns={columns}
                columnNames={columnNames}
                data={POReturnData}
              />
            )}

            {/*=========================== END OF LIST ==========================================================*/}
            <div className="container mt-4"></div>
            <div
              className="flex container"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={InsertPOData}
                title="Click for Data Save"
              >
                Save Data
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default PoPage;
